module.exports = __webpack_public_path__ + "img/Logo_HSE_header.bc598f11.png";